<template >
    <div>
        <div class="flex items-center py-5 !px-10 ">
            <Icon icon="teenyicons:user-circle-outline" class="!text-4xl" :color="colorAsRoute" />
            <v-card-title :class="`${routeLink}_fortext !text-3xl !font-semibold`">My Profile</v-card-title>
        </div>
        <div :class="`border-b-[1px]  ${routeLink}-border`"></div>
        <div class="p-10 pt-0 mt-10 overflow-auto sm:h-[calc(100vh-110px)] h-[calc(100vh-200px)]">
            <div class=" flex sm:items-center sm:gap-0 gap-3 sm:flex-row flex-col">
                <v-avatar rounded="xl" height="380px" width="280" :class="`!border-2 ${routeLink}-border`">
                    <v-img :src="loggedInUser.image" />
                </v-avatar>
                <div class="font-semibold font-Inter sm:px-5">
                    <div class="text-2xl text-gray-400">Bio</div>
                    <div :class="`${routeLink}_fortext   text-4xl font-bold`">{{ loggedInUser.name }}</div>
                    <v-list dense color="transparent" class="for_icon">
                        <v-list-item class="text-white pa-0">
                            <v-list-item-icon>
                                <!-- <v-icon :color="colorAsRoute">mdi-book-education</v-icon> -->
                                <Icon icon="emojione-monotone:school" class="!text-3xl" :color="colorAsRoute" />
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="!text-lg font-Inter font-semibold !capitalize pt-1">{{
                                    loggedInUser.education
                                }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="text-white pa-0">
                            <v-list-item-icon>
                                <Icon icon="bi:calendar2-heart" class="!text-3xl" :color="colorAsRoute" />
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="!text-lg font-Inter font-semibold !capitalize">{{
                                    loggedInUser.partner_age_range
                                }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="text-white pa-0">
                            <v-list-item-icon>
                                <Icon icon="ph:briefcase" class="!text-4xl" :color="colorAsRoute" />
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="!text-lg font-Inter font-semibold !capitalize">{{
                                    loggedInUser.job
                                }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <h3 class="text-xl my-2">
                        <span class="text-gray-400">Hobbies</span>
                    </h3>
                    <div class="hobbies flex gap-3 flex-wrap">
                        <v-chip close close-icon="mdi-delete" @click:close="deleteHobbies(item.id)"
                            :class="` hover:scale-110 !duration-500 font-Inter !transition-transform text-black for_spinner ${routeLink}_color` "
                            :color="`${routeLink}` == 'straight' ? '#cba440' : `${routeLink}` == 'gay' ? '#78a8f4' : `${routeLink}` == 'lesbian' ? '#a032f5' : ''"
                            v-for="item in loggedInUser.user_intrests" :key="item.key">
                            <v-icon v-show="interestdltLoading" left
                                :class="{ 'spinner': interestdltLoading }">mdi-loading</v-icon>
                            {{ item.interest.title }}
                        </v-chip>
                    </div>
                </div>
            </div>
            <div class="py-10">
                <div class="text-3xl font-Inter font-semibold  text-gray-400">About</div>
                <div class=" sm:w-3/4 mt-4 text-gray-300">{{ loggedInUser.about }}</div>
            </div>
            <div class="pb-10">
                <div class=" text-gray-400 text-3xl pb-4 font-semibold">
                    Gallery
                </div>
                <div class="flex overflow-x-auto">
                    <v-avatar width="200" height="200"
                                    :class="`!border-2 ${routeLink}-border group cursor-pointer !min-w-[200px]`"
                                    class="!mr-4 mb-4 !border-[2px] !border-gray-500 cursor-pointer group" rounded="lg"
                                    v-for="(item, idx)  in loggedInUser.user_images" :key="item.key">
                                    <div class="absolute top-0 left-0 z-20 w-full h-[85%]" @click="showMultiple(idx)"></div>
                                    <v-img :src="item.image" :lazy-src="item.image" aspect-ratio="1"
                                        gradient="to top, rgba(0,0,0,1), rgba(0,0,0,0)" class="grey lighten-2">
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                        <template v-slot:default>
                                            <div class="grid w-full h-full grid-flow-col align-items-end ">
                                                <v-btn text dark :color="checkLiked(item) ? colorAsRoute : ''"
                                                    @click.prevent="likeSetter(item)"
                                                    class="!opacity-0 group-hover:!opacity-100">
                                                    <v-icon :color="checkLiked(item) ? colorAsRoute : ''"
                                                        small>mdi-thumb-up</v-icon><span v-if="item.likes_count > 0"
                                                        class="ml-2">{{ item.likes_count }}</span>
                                                </v-btn>
                                                <v-btn text dark :color="checkLoved(item) ? colorAsRoute : ''"
                                                    @click.prevent="loveSetter(item)"
                                                    class="!opacity-0 group-hover:!opacity-100">
                                                    <v-icon :color="checkLoved(item) ? colorAsRoute : ''"
                                                        small>mdi-heart</v-icon><span v-if="item.loves_count > 0"
                                                        class="ml-2">{{ item.loves_count }}</span>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-img>

                                </v-avatar>
                </div>
                <div class=" bg-black !m-2 rounded-3xl !animate-pulse !grid place-items-center font-Handel text-xl "
                    v-if="!loggedInUser.user_images.length > 0">
                    No Images
                </div>
            </div>
        </div>
        <VueEasyLightbox moveDisabled :visible="visible" :imgs="images" :index="index" @hide="handleHide">
        </VueEasyLightbox>

    </div>
</template>

<script>
import { Icon } from '@iconify/vue2';
import axios from 'axios';
import VueEasyLightbox from 'vue-easy-lightbox'


export default {
    data() {
        return {
            interestdltLoading: false,
            images: [],
            visible: false,
            index: 0,  // defaults

        }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.StateUser.data
        },
        colorAsRoute() {
            if (this.routeLink == "straight") {
                return "#a07a1d";
            }
            else if (this.routeLink == "gay") {
                return "#88c3fa";
            }
            else if (this.routeLink == "lesbian") {
                return "#9e2eec";
            }
        },
    },
    methods: {
        async likeSetter(image) {
            try {
                const resp = await axios.post('users/like/image', {
                    image_id: image.id,
                    user_id: this.$store.getters.StateUser.data.id
                })
                if (resp.status == 200) {
                   const {data} = await axios.get('profiles')
                   this.$store.commit("setUser", data);
                }
            } catch (error) {
                console.log(error.response.data.message)
                await this.$store.dispatch("errorAction", error.response.data.message, {
                    root: true,
                })
            }
        },
        async loveSetter(image) {
            try {
                const resp = await axios.post('users/love/image', {
                    image_id: image.id,
                    user_id: this.$store.getters.StateUser.data.id
                })
                if (resp.status == 200) {
                    const {data} = await axios.get('profiles')
                   this.$store.commit("setUser", data);
                }
            } catch (error) {
                console.log(error.response.data.message)
                await this.$store.dispatch("errorAction", error.response.data.message, {
                    root: true,
                })
            }
        },
        checkLiked(item) {
            if (item.liked_by) {
                return true;
            } else {
                const userId = this.$store.getters.StateUser.data.id;
                return item.likes.find(e => e.liked_by == userId)
            }
        },
        checkLoved(item) {
            if (item.loved_by) {
                return true;
            } else {
                const userId = this.$store.getters.StateUser.data.id;
                return item.loves.find(e => e.loved_by == userId)
            }
        },
        async deleteHobbies(interestId) {
            const formData = new FormData()
            formData.append("is_delete_interests[]", interestId);
            try {
                this.interestdltLoading = true;
                const resp = await axios({
                    method: "post",
                    url: "update-profile",
                    data: formData,
                });
                this.$store.commit("setUser", resp.data);
            } catch (error) {
                console.log(error);
            }
            finally {
                this.interestdltLoading = false;
            }
        },

        async deleteImage(imageId) {
            const formData = new FormData()
            formData.append("is_delete_images[]", imageId);
            try {
                this.imageDltloading = true;
                const resp = await axios({
                    method: "post",
                    url: "update-profile",
                    data: formData,
                });
                this.$store.commit("setUser", resp.data);
            } catch (error) {
                console.log(error);
            }
            finally {
                this.imageDltloading = false;
            }
        },

        showMultiple(idx) {
            this.images = this.loggedInUser.user_images.map((item) => item.image)
            this.index = idx  // index of imgList
            this.show()
        },
        show() {
            this.visible = true
        },
        handleHide() {
            this.visible = false
        },
    },
    components: { Icon, VueEasyLightbox }
}
</script>


<style scoped>
.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}

.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(180deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.for_icon:deep(.v-list-item__icon) {
    height: initial !important;
    margin: 16px 0 !important;
    margin-right: 32px !important;
}

.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(180deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%) !important;
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(180deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%) !important;
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(180deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%) !important;
}

.spinner {
    animation: spin 0.5s linear infinite;
}

@-webkit-keyframes spin {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(360deg)
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(360deg)
    }
}
</style>